import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SlideContainer from './SlideContainer';
import SlideList from './SlideList';

import { AdminContext } from '../../../contexts/admin.context';

export default function Slide5({
  title = 'Mes 2 modes de communication avec lesquels je me sens le plus à l’aise ',
  buttonText = 'Modifier',
  type = 'a'
}) {
  const {
    portalConfig: { basePath } = {},
    studentProfile: { communicationPreferences }
  } = useContext(AdminContext);

  const { t } = useTranslation();

  const options = t('resources.starsList', { returnObjects: true });

  const [listedCommunicationPreferences, setListedCommunicationPreferences] = useState([]);

  useEffect(() => {
    try {
      const studentPrefsType = communicationPreferences?.[type];

      const keys = Object.keys(studentPrefsType);
      if (!keys.length) return;

      let list = [];

      keys.forEach((key) => {
        const optionsOfThisKey = options[key];

        const selectedOptions = Object.keys(studentPrefsType[key]);

        selectedOptions.forEach((option) => {
          list.push(optionsOfThisKey[option]);
        });
      });

      setListedCommunicationPreferences(list);
    } catch (error) {
      console.log(error);
    }
  }, [communicationPreferences]);

  return (
    <SlideContainer
      title={title}
      buttonText={buttonText}
      link={basePath + (type === 'a' ? '/student-profile-4' : '/student-profile-5')}>
      <SlideList items={listedCommunicationPreferences} withTranslations={false} />
    </SlideContainer>
  );
}
